"use client";

import { useEffect, useState } from "react";
import { usePathname, useRouter } from "next/navigation";
import { Users, LayoutDashboard } from "lucide-react";
import { buscarJsonComCache } from "@/lib/fetch-cache-cliente";
import { useUnsavedChangesNavigation } from "./UnsavedChangesGuard";

export function GestorToggle() {
  const [isGestor, setIsGestor] = useState(false);
  const pathname = usePathname();
  const router = useRouter();
  const { protegerSaida } = useUnsavedChangesNavigation();

  useEffect(() => {
    buscarJsonComCache<{ papel?: string }>("/api/me", { ttl: 120_000 })
      .then((d) => setIsGestor(d.papel === "GESTOR"))
      .catch(() => {});
  }, []);

  if (!isGestor) return null;

  const modoEquipe = pathname.startsWith("/gestor");

  return (
    <button
      onClick={() => protegerSaida(() => router.push(modoEquipe ? "/" : "/gestor/inicio"))}
      title={modoEquipe ? "Ir para minha carteira" : "Ir para minha equipe"}
      className="flex h-11 w-11 items-center justify-center rounded-xl border border-border text-muted transition-colors hover:text-navy lg:h-12 lg:w-12 lg:rounded-2xl"
    >
      {modoEquipe ? (
        <LayoutDashboard className="h-[18px] w-[18px]" />
      ) : (
        <Users className="h-[18px] w-[18px]" />
      )}
    </button>
  );
}
